import React from "react";
import CloseIcon from "react-icons/lib/md/close";
import "./index.scss";

export default function Modal(props) {
  const { isOpen, renderCloseIcon = true } = props;
  if (!isOpen) return null;

  const modalStyle = { ...props.modalStyle };

  return (
    <div onClick={onClose} className="modal-backdrop">
      <div
        onClick={(e) => e.stopPropagation()}
        className="modal-card"
        style={modalStyle}
      >
        {renderCloseIcon && (
          <CloseIcon className="modal-xicon" onClick={onClose} />
        )}
        {props.children}
      </div>
    </div>
  );

  function onClose() {
    if (props.onClose) props.onClose();
  }
}
